import type { Pills } from 'node_modules/@seek/chalice-types';

import type { JobSearchAssistPills } from 'src/graphql/graphql';
import { useDispatch, useSelector } from 'src/store/react';
import { updateBaseKeywordParam, updateKeywordsField } from 'src/store/search';
import { selectBaseKeywords } from 'src/store/search/selectors';
import { useRunSearch } from 'src/store/search/useRunSearch';
import {
  selectFeatureFlag,
  selectIsJobSearchAssistLoading,
  selectPills,
  selectJobSearchAssistPills,
  selectIsResultsLoading,
} from 'src/store/selectors';

export type JobSearchAssist = {
  isLoading: boolean;
  pills: Pills | JobSearchAssistPills['data'];
  onPillClick: (keyword: string) => void;
};

export const useJobSearchAssist = (): JobSearchAssist => {
  const dispatch = useDispatch();
  const isJobSearchAssistEnabled = useSelector(
    selectFeatureFlag('isJobSearchAssistEnabled'),
  );
  const runSearch = useRunSearch();
  const baseKeywords = useSelector(selectBaseKeywords);
  const jobSearchAssistPills = useSelector(selectJobSearchAssistPills);
  const isJobSearchAssistLoading = useSelector(selectIsJobSearchAssistLoading);

  const pills = useSelector(selectPills);
  const isLoading = useSelector(selectIsResultsLoading);

  return isJobSearchAssistEnabled
    ? {
        isLoading: isJobSearchAssistLoading,
        pills: jobSearchAssistPills || [],
        onPillClick: (keyword: string) => {
          dispatch(updateKeywordsField(keyword));
          dispatch(runSearch({ pathname: '/jobs' }));
        },
      }
    : {
        isLoading,
        pills: pills || [],
        onPillClick: (keyword: string) => {
          if (!baseKeywords) {
            dispatch(updateBaseKeywordParam(keyword));
          }
          dispatch(updateKeywordsField(keyword));
          dispatch(runSearch({ pathname: '/jobs' }));
        },
      };
};

export default useJobSearchAssist;
